<script>
  import { ActionBar, GridContainer } from "@ObamaFoundation/of-design-system";
  import { getContext } from "svelte";

  /** @type { string } */
  let className = "";
  export { className as class };

  export let text;
  export let actions = null;
  export let location = null;
  export let showActionItemDetailsOnMobile = false;

  const isContainerized = !!getContext("containerized");
</script>

{#if isContainerized}
  <ActionBar {text} {actions} {location} {showActionItemDetailsOnMobile} />
{:else}
  <GridContainer containerClass={className}>
    <ActionBar {text} {actions} {location} {showActionItemDetailsOnMobile} />
  </GridContainer>
{/if}
